export default "__VITE_ASSET__b19ebfce__"